<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Erklärung zu Barrierefreiheit</h3>
        <!--
        <h5 class="description list">
          AutoEdge 24 - Inhaber: Andreas Leibolt<br>
          Grüsener Str. 17a<br>
          35285 Gemünden<br>
          Telefon: +49 176 55980480<br>
          E-Mail: kontakt@autoedge24.de<br>
          Internet: www.autoedge24.de
        </h5>
        -->
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Geltungsbereich</h4>
            <h5 class="description list">
              Diese Erklärung zur Barrierefreiheit gilt für das Online-Angebot von AutoEdge 24, sowie für alle weiteren digitalen Inhalte des Unternehmens.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Stand der Vereinbarkeit mit den Anforderungen</h4>
            <h5 class="description list">
              Wir sind bemüht, unsere Website und digitalen Inhalte im Einklang mit den geltenden gesetzlichen Bestimmungen zur Barrierefreiheit – insbesondere der Richtlinie (EU) 2016/2102 und dem Barrierefreiheitsstärkungsgesetz (BFSG) – barrierefrei zugänglich zu gestalten.
              Der aktuelle Stand basiert auf einer Selbstbewertung.
              Die meisten Inhalte sind barrierefrei nutzbar.
              Einzelne PDF-Dokumente und eingebettete Inhalte könnten noch nicht vollständig den Barrierefreiheitsanforderungen entsprechen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Nicht barrierefreie Inhalte</h4>
            <h5 class="description list">
              Eingebettete Drittanbieter-Inhalte (z. B. Karten, Videos) können derzeit Einschränkungen aufweisen.
              Einige ältere PDF-Dokumente sind nicht barrierefrei.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Erstellung dieser Erklärung</h4>
            <h5 class="description list">
              Diese Erklärung wurde am 07.11.2025 erstellt.
              Letzte Überprüfung: 07.11.2025.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Feedback und Kontakt</h4>
            <h5 class="description list">
              Falls Sie auf Barrieren in unserem Internetauftritt stoßen oder Anmerkungen haben, kontaktieren Sie uns bitte:<br>
              AutoEdge 24 - Inh. Andreas Leibolt<br>
              Grüsener Str. 17a<br>
              35285 Gemünden<br>
              Telefon: +49 176 55980480<br>
              E-Mail: kontakt@autoedge24.de<br>
              Wir werden uns bemühen, Ihre Anfrage zeitnah zu prüfen und Abhilfe zu schaffen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">6. Online-Streitbeilegung</h4>
            <h5 class="description list">
              Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit: <a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'privacy',
  bodyClass: 'privacy-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
